export default __webpack_public_path__ + "./static/site-image.png";